<template>
  <p class="mb-2 t-sm description pr-3"
    v-line-clamp="lineClamp"
  >
    <span class="t-600">{{'Intervention' | pluralize(interventions)}}: </span>
    <span>{{ interventions | separateByComma('name')}}</span>
  </p>
</template>

<script>
export default {
  name: 'searchResultPartialInterventions',
  props: {
    interventions: {
      type: Array,
      required: true
    },
    lineClamp: {
      type: Number,
      default: 2
    }
  }
}
</script>
